/** This script was auto generated by 'TypeValidatorCreator' at 'src/infrastructure/scripts/Typescript/TypeValidator.ts' **/
import { createValidator } from '../../../schema'
import type {
    MinimalSchemasResponse,
    MinimalValidationError,
    MinimalValidationErrors,
} from './Types'

const MinimalValidationErrorsSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalValidationErrors',
    definitions: {
        MinimalValidationErrors: { type: 'array', items: { $ref: '#/definitions/MinimalValidationError' }, minItems: 1, maxItems: 1, deprecated: true },
        MinimalValidationError: { type: 'object', properties: { message: { type: 'string' } }, required: ['message'], deprecated: true },
    },
}
export const isMinimalValidationErrors = createValidator<MinimalValidationErrors>(MinimalValidationErrorsSchema, 'isMinimalValidationErrors')
const MinimalValidationErrorSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalValidationError',
    definitions: { MinimalValidationError: { type: 'object', properties: { message: { type: 'string' } }, required: ['message'], deprecated: true } },
}
export const isMinimalValidationError = createValidator<MinimalValidationError>(MinimalValidationErrorSchema, 'isMinimalValidationError')
const MinimalSchemasResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalSchemasResponse',
    definitions: {
        MinimalSchemasResponse: {
            type: 'object',
            properties: { schemas: { $ref: '#/definitions/ReadonlyRecord%3Cstring%2Cunknown%3E' } },
            required: ['schemas'],
            deprecated: true,
        },
        'ReadonlyRecord<string,unknown>': { type: 'object', additionalProperties: {} },
    },
}
export const isMinimalSchemasResponse = createValidator<MinimalSchemasResponse>(MinimalSchemasResponseSchema, 'isMinimalSchemasResponse')
